import { IconName, Icon, IconColorType } from '@frontend/icons';
import { FontColorType } from '@frontend/design-system';

export const getActionIcon = ({ iconName, color = 'default' }: { color?: FontColorType; iconName: IconName }) => {
  return <Icon name={iconName} size={16} color={color as IconColorType} />;
};
